module.exports = __webpack_public_path__ + "static/nectar-museum-1-d4205354899d71719ec92033127dee39.jpg";